import React from "react";
import { Col } from "reactstrap";
import ShortcutModal from "./ShortcutModal";
import { useTranslation } from "react-i18next";
const Notifs = () => {
  const { t } = useTranslation();
  return (
    <div>
      <div style={{ height: "6vh" }}>
        <Col className="text-center modalTitle fn">{t("پیام های من")}</Col>
      </div>
      <div style={{ minHeight: "70vh" }}>
        <div>
          <div className="notifsDay fn10 text-center text-muted">
            {t("امروز")}
          </div>
        </div>
        <div className="my-3">
          <div className="d-flex justify-content-around w-100 my-2">
            <Col className="col-2">
              <i className="notifsMessageIcon d-block bg-white rounded-circle"></i>
            </Col>
            <Col className="col-6 mr-2 p-0">
              <div className="text-right">
                <p className="m-0 fn10">{t("خوش آمدید")}</p>
                {/* <small className="fn10">برای روی  <span className="notifHomeColor">خانه شمال</span></small> */}
              </div>
            </Col>
            {/* <Col className="col-3 p-0">
                            <i className="rejectIcon d-inline-block bg-white rounded-circle ml-2"></i>
                            <i className="confirmIcon d-inline-block bg-white rounded-circle"></i>
                        </Col> */}
          </div>

          {/* <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-white rounded-circle"></i>
                        </Col>
                        <Col className="col-6 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دعوت از طرف پریرخ ترابی</p>
                                <small className="fn10">برای روی  <span className="notifHomeColor">خانه یک</span></small>
                            </div>
                        </Col>
                        <Col className="col-3 p-0">
                            <p className="m-0 text-success fn10">تائید شده</p>
                        </Col>
                    </div>

                    <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-white rounded-circle"></i>
                        </Col>
                        <Col className="col-6 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دعوت از طرف پریرخ ترابی</p>
                                <small className="fn10">برای روی  <span className="notifHomeColor">خانه پریرخ</span></small>
                            </div>
                        </Col>
                        <Col className="col-3 p-0">
                            <p className="m-0 text-danger fn10">رد شده</p>
                        </Col>
                    </div>
                </div>


                <div>
                    <div className="notifsDay fn10 text-center fn12 text-muted">1399/11/4</div>
                </div>
                <div className="my-3"> */}
          {/* <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-red rounded-circle"></i>
                        </Col>
                        <Col className="col-9 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دستگاه جدید در دستگاه قرار گرفت</p>
                                <small className="fn10">لامپ مدل TG-223</small>
                            </div>
                        </Col>
                    </div>

                    <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-green rounded-circle"></i>
                        </Col>
                        <Col className="col-9 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دستگاه جدیدی ثبت شد</p>
                                <small className="fn10">لامپ مدل TG-223</small>
                            </div>
                        </Col>
                    </div>
                </div>

                <div>
                    <div className="notifsDay fn10 text-center text-muted">1399/11/4</div>
                </div>
                <div className="my-3"> */}
          {/* <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-red rounded-circle"></i>
                        </Col>
                        <Col className="col-9 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دستگاه از دسترس خارج شد</p>
                                <small className="fn10">لامپ مدل TG-223</small>
                            </div>
                        </Col>
                    </div>

                    <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-red rounded-circle"></i>
                        </Col>
                        <Col className="col-9 mr-2 p-0">
                            <div className="text-right">
                                <p className="m-0 fn10">دستگاه جدیدی در دسترس قرار گرفت</p>
                                <small className="fn10">لامپ مدل TG-223</small>
                            </div>
                        </Col>
                    </div> */}

          {/* <div className="d-flex justify-content-around w-100 my-2">
                        <Col className="col-2">
                            <i className="notifsMessageIcon d-block bg-white rounded-circle"></i>
                        </Col>
                        <Col className="p-0 col-6 mr-2">
                            <div className="text-right">
                                <p className="m-0 fn10">دعوت از طرف پریرخ ترابی</p>
                                <small className="fn10">برای روی  <span className="notifHomeColor">خانه پریرخ</span></small>
                            </div>
                        </Col>
                        <Col className="p-0 col-3">
                            <p className="m-0 text-danger fn10">رد شده</p>
                        </Col>
                    </div> */}
        </div>
      </div>
      <ShortcutModal />
    </div>
  );
};

export { Notifs };
